import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { typedStore } from '@/store';
import {onResponseRejectedRerouteUnauthorizedRequest} from '@/interceptor-methods';

const VatsAPI = axios.create({
    baseURL: '/api/',
    headers: {
        common: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    },
});

VatsAPI.interceptors.request.use(
    (config) => {
        typedStore.modules.loaderModule.mutations.startLoading('VatsAPI');
        return config;
    },
    (error) => {
        const request = error.request as AxiosRequestConfig;
        typedStore.modules.loaderModule.mutations.finishLoading('VatsAPI');
        return Promise.reject(error);
    });

VatsAPI.interceptors.response.use((response) => {
    typedStore.modules.loaderModule.mutations.finishLoading('VatsAPI');
    return response;
}, (error) => {
    typedStore.modules.loaderModule.mutations.finishLoading('VatsAPI');
    return onResponseRejectedRerouteUnauthorizedRequest(error);
});

export default VatsAPI;
